import { Flex } from '@chakra-ui/layout';
import { Header } from '../../../../components/Header';
import { Sidebar } from '../../../../components/Sidebar';

export const DefaultLayout: React.FC = ({ children }) => (
  <Flex direction="column" minH="100vh">
    <Header />
    <Flex minH="100vh">
      <Sidebar />
      <Flex w="100%" my="6" px="6">
        {children}
      </Flex>
    </Flex>
  </Flex>
);
